import { makeSvgImage } from '../../../../../../components/SvgImage/index.ts';

export const DarkCloudA = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 26">
    <path
      fill="#EFF7FF"
      fillRule="evenodd"
      d="M14 12.6a4 4 0 0 1-.5-2c0-6 9.6-10.6 21.4-10.6 9.8 0 18 3.2 20.5 7.7 2-.3 3.9-.5 6-.5 10.3 0 18.6 4.1 18.6 9.3 0 4.8-7.6 8.8-17.3 9.2H13.4C6 25.7 0 22.7 0 19.1c0-3.6 6-6.5 13.4-6.5h.5Z"
      clipRule="evenodd"
    />
  </svg>,
);
